<template>
  <div class="container container-width">
    <b-card class="max-width mt-5">
      <!-- Logo -->
      <div class="d-flex justify-content-center align-items-center mr-3 mt-2 mb-4">
        <img
          class="logo-login"
          :src="`${publicUrl}img/logo/eines-logo.svg`"
          alt
        />
      </div>
      <!-- / Logo -->

      <h4 class="text-center mt-3 mb-2">
        {{ $t("login.account") }}
      </h4>

      <div class="text-center mt-2 mb-2">
        {{ $t("login.notaccount") }}
        <a href="#/register">{{ $t("register.createaccount") }}</a>
      </div>

      <b-alert
        class="font-weight-normal"
        v-model="showPasswordAlert"
        variant="danger"
        dismissible
      >
        Feil brukernavn eller passord, vennligst prøv igjen.
      </b-alert>

      <b-alert
        class="font-weight-normal"
        v-model="showErrorAlert"
        variant="danger"
        dismissible
      >
        Noe gikk galt, vennligst kontakt
        <a href="mailto:post@eines-as.no">post@eines-as.no</a> for hjelp.
      </b-alert>

      <!-- Form -->
      <form class="mt-4" @submit.prevent="login">
        <b-form-group :label="$t('login.email')">
          <b-form-input
            type="email"
            v-model.trim="identifier"
            :disabled="isLoading"
          />
        </b-form-group>

        <b-form-group>
          <div slot="label" class="d-flex justify-content-between align-items-end">
            <div>{{ $t("login.password") }}</div>
          </div>
          <b-form-input
            type="password"
            v-model="password"
            @input="showPasswordAlert = false; showErrorAlert = false"
            :disabled="isLoading"
          />
          <a href="/#/password-forgot" class="d-block small">
            {{ $t("login.forgotpassword") }}
          </a>
        </b-form-group>

        <div class="d-flex justify-content-between align-items-center mt-2 mb-3">
          <b-button
            type="submit"
            variant="primary"
            block
            :disabled="isLoading"
          >
            <span v-if="!isLoading">{{ $t("login.login") }}</span>
            <span v-else>Logger inn…</span>
          </b-button>
        </div>
      </form>
      <!-- / Form -->
    </b-card>

    <div class="text-center">
      <small class="mt-6 mb-3 text-muted">&copy; 2025 - Eines AS</small>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default {
  data() {
    return {
      identifier: "",
      password: "",
      showPasswordAlert: false,
      showErrorAlert: false,
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    login() {
      // 1) reset any old error banners
      this.showPasswordAlert = false;
      this.showErrorAlert = false;

      // 2) start loading
      this.isLoading = true;

      this.$store
        .dispatch("login", {
          identifier: this.identifier,
          password: this.password,
        })
        .then((response) => {
          // on success, route based on type…
          if (response.data.user.wizard === false) {
            this.$router.push("/wizard");
          } else if (response.data.user.company.type === "Supplier") {
            this.$router.push("/dashboard/home");
          } else if (response.data.user.company.type === "Customer") {
            this.$router.push("/customer/home");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            // wrong credentials
            this.showPasswordAlert = true;
            this.password = ""; // clear out for retry
          } else if (error.request) {
            // no reply
            this.showErrorAlert = true;
          } else {
            // something else went sideways
            this.showErrorAlert = true;
          }
        })
        .finally(() => {
          // 3) always turn off loading
          this.isLoading = false;
        });
    },
    redirect() {
      if (this.isLoggedIn == true) {
        axios.get("https://api.aquaservices.no/users/me").then((res) => {
          this.user = res.data;
          this.company = res.data.company;

          if (this.user.wizard == false) {
            this.$router.push("/wizard");
          }
          if (this.company.type == "Customer") {
            this.$router.push("/customer/home");
          }
          if (this.company.type == "Supplier") {
            this.$router.push("/dashboard/home");
          } else {
          }
        });
      }
      }
  },
  created: function () {
    this.redirect();
   // this.getIPlocation();
  },
};
</script>

<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>

<style lang="css">
.logo-login {
  width: 200px !important;
}

.container-width {
  max-width: 475px !important;
}
</style>
